import { render, staticRenderFns } from "./index.vue?vue&type=template&id=52f750ae"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=52f750ae&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52f750ae')) {
      api.createRecord('52f750ae', component.options)
    } else {
      api.reload('52f750ae', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=52f750ae", function () {
      api.rerender('52f750ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PdfPreview/index.vue"
export default component.exports